import React, { FC } from 'react';

export interface FeedbackIconProps {
  size: number;
  style: Record<string, string | number>;
}

const FeedbackIcon: FC<React.PropsWithChildren<FeedbackIconProps>> = ({ size, style }) => (
  <svg
    width={size}
    height={size}
    style={style}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M0.5075 2C0.5075 1.175 1.175 0.5 2 0.5H14C14.825 0.5 15.5 1.175 15.5 2V11C15.5 11.825 14.825 12.5 14 12.5H3.5L0.5 15.5L0.5075 2ZM3.5 9.5H12.5V8H3.5V9.5ZM3.5 7.25H12.5V5.75H3.5V7.25ZM3.5 5H12.5V3.5H3.5V5Z'
      fill='currentColor'
    />
  </svg>
);

export default FeedbackIcon;
